import { FC, useCallback, useEffect, useMemo, useState } from 'react';
import { ScrollView, Text, View } from 'react-native';
import DropDown from '../../components/DropDown';
import { Footer } from '../../components/Footer';
import { useIsDesktop } from '../../hooks/useIsDeskTop';
import { AccountTable } from './components/AccountTable';
import { accountStatementStyled as styled } from './styled';
import { AccountStatementProps } from './types';
import MyAccountLayout from '../../components/MyAccountLayout/MyAccountLayout';
import { DropDownItem } from '../../models/DropDownItem';
import dayjs from 'dayjs';
import PageTitle from '../../components/PageTitle';
import { IStatement } from '../../types/auth.types';
import { AuthApi, GetMyAccountProps } from '../../services/api/auth.api';
import { Loading } from '../../components';
import { NavigationService } from '../../services/navigation';

const AccountStatement: FC<AccountStatementProps> = ({ navigation }) => {
  const isDesktop = useIsDesktop();
  const [statements, setStatements] = useState<IStatement[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [totalBalance, setTotalBalance] = useState<number>(0);

  const getStatements = useCallback(async (props: GetMyAccountProps) => {
    try {
      setIsLoading(true);
      const res = await AuthApi.getMyAccount(props);
      setStatements(res.data.statements);
      setTotalBalance(res.data.bbalance);
    } catch (error: any) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  }, []);

  const totalCharge = useMemo(() => {
    var total: number = 0;
    statements.map((item) => {
      total = total + item.amount;
    });
    return total;
  }, [statements]);

  const setValueDropdown = (value: DropDownItem) => {
    const selectedDate = new Date(value.value);
    getStatements({
      year: selectedDate.getFullYear(),
      month: selectedDate.getMonth() + 1,
    });
  };

  const monthOptions = useMemo(() => {
    let currentDate = new Date();
    const months: DropDownItem[] = [];
    for (let i = 0; i < 12; i++) {
      let pastMonth = new Date(
        currentDate.getFullYear(),
        currentDate.getMonth() - i,
        1
      );
      months.push({
        label: dayjs(pastMonth).format('MMMM YYYY'),
        value: dayjs(pastMonth).format('YYYY-MM'),
      });
    }
    return months;
  }, []);

  useEffect(() => {
    let currentDate = new Date();
    getStatements({
      year: currentDate.getFullYear(),
      month: currentDate.getMonth() + 1,
    });
  }, [getStatements]);

  if (isDesktop()) {
    return (
      <MyAccountLayout
        title="My account statement"
        current={1}
        icon={require('../../assets/accout-statement-logo.png')}
      >
        <View style={{ zIndex: 1000 }}>
          <Text style={styled.dropdownNote}>
            Account statement will display the most recent 1 month's
            transactions at KCC, from the month selected:
          </Text>
          <View style={{ width: '30%', minWidth: 200 }}>
            <DropDown
              setValues={setValueDropdown}
              items={monthOptions}
              dropDownContainerStyled={{ top: 42 }}
              initValue={monthOptions[0]}
            />
          </View>
        </View>
        {isLoading === true ? (
          <View style={{ marginTop: 20 }}>
            <Loading />
          </View>
        ) : (
          <AccountTable
            data={statements}
            totalBalance={totalBalance}
            totalCharges={totalCharge}
          />
        )}
      </MyAccountLayout>
    );
  }

  return (
    <ScrollView showsVerticalScrollIndicator={false}>
      <View style={styled.container}>
        <PageTitle
          title={`My account\nstatement`}
          icon={require('../../assets/accout-statement-logo.png')}
          haveGoBackButton={true}
          style={{ borderBottomWidth: 0, marginBottom: 0 }}
          handleGoBack={() => {
            NavigationService.push('Root', {
              screen: 'MyAccountTab',
            });
          }}
        />
      </View>
      <View style={[styled.container, { zIndex: 1000 }]}>
        <Text style={styled.dropdownNote}>
          Account statement will display the most recent 1 month's transactions
          at KCC, from the month selected:
        </Text>
        <View style={{ width: '50%', zIndex: 1000 }}>
          <DropDown
            setValues={setValueDropdown}
            title="Please Select Month"
            placeholder="Select Month"
            items={monthOptions}
            initValue={monthOptions[0]}
          />
        </View>
      </View>
      {isLoading === true ? (
        <View style={{ marginTop: 20, marginBottom: 20 }}>
          <Loading />
        </View>
      ) : (
        <AccountTable
          data={statements}
          totalBalance={totalBalance}
          totalCharges={totalCharge}
        />
      )}
      <Footer />
    </ScrollView>
  );
};

export default AccountStatement;
